var BackgroundComponent = /** @class */ (function () {
    function BackgroundComponent() {
    }
    return BackgroundComponent;
}());
export { BackgroundComponent };
